import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { Direcciones } from '../../core/model/direcciones';
import { Provincias } from '../../core/model/provincias';
import { ResizedEvent } from '../../core/model/resized-event';
import { DireccionesService } from '../../core/services/direcciones.service';
import { PopulateService } from '../../core/services/populate.service';
import { UsersService } from '../../core/services/users.service';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';
import { ModalConfirmationComponent } from '../../utils/modal-confirmation/modal-confirmation.component';
import { AuthenticationService } from '../../core/services/authentication.service';






@Component({
    selector: 'app-direcciones',
    templateUrl: './direcciones.component.html',
    styleUrls: ['./direcciones.component.css'],
    providers: [DireccionesService, BsModalService, PopulateService]
})

export class DireccionesComponent implements OnInit, OnDestroy {
    @ViewChild('table') table: DatatableComponent;

    //  Propiedades del componente
    userAddresses: Direcciones[];
    provinciaList: Provincias[];
    statusCode: number;
    requestProcessing = false;
    directionIdToUpdate = null;
    directionIdToDelete = null;
    processValidation = false;
    mensajeToShow: string;
    noHayPorDefecto = true;
    modalRef: BsModalRef;
    selectedIdProvincia = 0; // Seleccione provincia
    model = new Direcciones();
    minCodPostal = false;
    tableColumns: any[] = [];
    isSsoAuthenticate = false;


    // ngx-datatable config
    customMessages = {
        emptyMessage: 'No hay direcciones que mostrar. Añada una nueva',
        totalMessage: 'Total',
        selectedMessage: 'Selección'
    };
    customClasses = {
        sortAscending: 'fas fa-sort-up',
        sortDescending: 'fas fa-sort-down',
        pagerLeftArrow: 'fas fa-chevron-left',
        pagerRightArrow: 'fas fa-chevron-right',
        pagerPrevious: 'fas fa-step-backward',
        pagerNext: 'fas fa-step-forward'
    };

    // for languages
    private subscription;
    private subscription_change;
    // for api
    private subscription_update;
    private subscription_get;
    private subscription_get_prov;
    private subscription_delete;
    private subscription_add;


    directionForm = this.fb.group({
        nombre: [this.model.NOMBRE, [Validators.required, Validators.maxLength(50)]],
        direccion: [this.model.DIRECCION, [Validators.required, Validators.maxLength(50)]],
        telefono: [this.model.TELEFONO, [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
        poblacion: [this.model.POBLACION, [Validators.required, Validators.maxLength(25)]],
        provincia: [this.model.ID_PROVINCIA, [Validators.required, Validators.min(1)]],
        CODIGO_POSTAL: [this.model.CODIGO_POSTAL, [
            Validators.required,
            Validators.pattern(/^-?(0|[1-9]\d*)?$/),
            Validators.max(52998),
            Validators.maxLength(5)
        ]],
    });

    get nombre() { return this.directionForm.get('nombre'); }
    get direccion() { return this.directionForm.get('direccion'); }
    get telefono() { return this.directionForm.get('telefono'); }
    get poblacion() { return this.directionForm.get('poblacion'); }
    get provincia() { return this.directionForm.get('provincia'); }
    get CODIGO_POSTAL() { return this.directionForm.get('CODIGO_POSTAL'); }
    get ID_PROVINCIA() { return this.directionForm.get('ID_PROVINCIA'); }

    constructor(
        private http: HttpClient,
        private direccionesservice: DireccionesService,
        private populateservice: PopulateService,
        private usersservice: UsersService,
        private toastr: ToastrService,
        private modalService: BsModalService,
        private translateService: TranslateService,
        private utilservice: UtilitiesService,
        private fb: FormBuilder,
        private authService: AuthenticationService) { }

    ngOnInit(): void {
        this.isSsoAuthenticate = this.authService.isSsoAuthentication();
        this.getUserAddresses();
        // Cargamos los combos necesarios para el alta y la modificación
        this.getAllProvincias();
        this.initTableColumns();
    }

    private initTableColumns() {
        this.tableColumns = [
            { name: this.translateService.instant('direcciones.columns.Id'), prop: 'Id' },
            { name: this.translateService.instant('direcciones.columns.Name'), prop: 'NOMBRE' },
            { name: this.translateService.instant('direcciones.columns.Address'), prop: 'DIRECCION' },
            { name: this.translateService.instant('direcciones.columns.PostalCode'), prop: 'CODIGO_POSTAL' },
            { name: this.translateService.instant('direcciones.columns.Population'), prop: 'POBLACION' },
            { name: this.translateService.instant('direcciones.columns.Province'), prop: 'PROVINCIA' },
            { name: this.translateService.instant('direcciones.columns.Phone'), prop: 'TELEFONO' }
        ];
    }

    getAllProvincias() {
        this.subscription_get_prov = this.populateservice.getAllProvincias()
            .subscribe(prov => {
                this.provinciaList = new Array();
                this.provinciaList = prov;
            },
                errorCode => {
                    this.statusCode = errorCode;
                    this.toastr.warning('No se han podido cargar las provincias', 'Error al cargar');
                });
    }
    //  Fetch all directions
    getUserAddresses() {
        this.preProcessConfigurations('Cargando direcciones');
        this.subscription_get = this.usersservice.getUserById(undefined)
            .subscribe(data => {
                this.userAddresses = data.DIRECCIONES;
                this.requestProcessing = false;

                this.noHayPorDefecto = false;
                if (this.userAddresses) {
                    this.userAddresses.forEach(address => {
                        if (address.POR_DEFECTO === true || address.DEFAULT === true) {
                            this.noHayPorDefecto = true;
                            return;
                        }
                    });
                }
            },
                errorCode => {
                    this.statusCode = 500;
                    // this.subscription = this.translateService.get(['mensajes'])
                    //    .subscribe(values => {
                    //        this.toastr.warning(values['mensajes']['nodata'], values['mensajes']['nodatatitle']);
                    //    });

                    this.toastr.warning('No se han podido cargar las direcciones', 'Error al cargar');
                });
    }

    //  Handle create and update address
    onAddressFormSubmit() {
        this.processValidation = true;
        if (this.directionForm.invalid) {
            return; //  Validation failed, exit from method.
        }
        //  Form is valid, now perform create or update
        // const direction = this.directionForm.value;
        if (this.directionIdToUpdate === null) {
            // direction.id = null;
            if (this.userAddresses.length === 0) {
                this.model.POR_DEFECTO = true;
            } else {
                this.model.POR_DEFECTO = false;
            }
            // direction.ID_USUARIO = 0; // this.authservice.getIdUsuario();
            this.preProcessConfigurations('Añadiendo direccion');
            //  Generate address id then create address
            this.modalRef.hide();
            //  Create address
            this.subscription_add = this.direccionesservice.createAddress(this.model)
                .subscribe(successCode => {
                    this.statusCode = successCode;
                    // asociar la direccion al usuario
                    this.toastr.success('Direccion añadida correctamente', 'Direccion correcta');
                    this.getUserAddresses();
                    this.backToCreateAddress();
                },
                    errorCode => {
                        this.muestraError(errorCode, '');
                    }
                );
            // this.getUserAddresses();
            // this.backToCreateAddress();


        } else {
            //  Handle update address
            this.model.Id = this.directionIdToUpdate;
            this.preProcessConfigurations('Modificando direccion');
            this.modalRef.hide();
            this.subscription_update = this.direccionesservice.updateAddress(this.model)
                .subscribe(successCode => {
                    this.toastr.success('Direccion modificada correctamente', 'Direccion modificada');
                    this.statusCode = successCode;
                    this.getUserAddresses();
                    this.backToCreateAddress();
                },
                    errorCode => {
                        this.muestraError(errorCode, '');
                    }
                );
        }
    }

    //  Load address by id to edit
    loadDirectionToEdit(id: number) {
        this.directionIdToUpdate = id;
        const direccionToUpdate = this.userAddresses.filter((dir: Direcciones) => dir.Id === id)[0];
        this.selectedIdProvincia = direccionToUpdate.ID_PROVINCIA;

        this.model.NOMBRE = direccionToUpdate.NOMBRE;
        this.model.DIRECCION = direccionToUpdate.DIRECCION;
        this.model.POBLACION = direccionToUpdate.POBLACION;
        this.model.ID_PROVINCIA = this.selectedIdProvincia;
        this.model.PROVINCIA = direccionToUpdate.PROVINCIA;
        this.model.CODIGO_POSTAL = direccionToUpdate.CODIGO_POSTAL;
        this.model.TELEFONO = direccionToUpdate.TELEFONO;

        this.processValidation = true;
        // posicionamos el select con el ID_PROVINCIA
    }


    defaultDirection(id: number) {
        this.preProcessConfigurations('Modificando direccion');
        this.subscription_update = this.direccionesservice.setAddressDefault(id)
            .subscribe(successCode => {
                this.toastr.success('Direccion modificada correctamente', 'Direccion por defecto');
                this.statusCode = successCode.status;
                this.getUserAddresses();
                this.backToCreateAddress();
            },
                errorCode => {
                    this.muestraError(errorCode, '');
                }
            );
    }
    //  Delete address
    deleteDirection(id: number) {
        this.directionIdToDelete = id;
        //  if (confirm('Vas a eliminar esta direccion, ¿esta seguro/a?')) {
        //   TODO:  Do something here if the answer is "Ok".
        this.preProcessConfigurations('Eliminando direccion');
        this.subscription_delete = this.direccionesservice.deleteAddressById(id)
            .subscribe(result => {
                //  this.statusCode = successCode;
                //  Expecting success code 204 from server
                this.statusCode = 204;
                this.toastr.success('Direccion eliminada correctamente', 'Direccion eliminada');
                this.getUserAddresses();
                this.backToCreateAddress();
            },
                errorCode => {
                    this.muestraError(errorCode, '');
                });
        // }
    }

    public showConfirmationModal(id: number): void {
        const modal = this.modalService.show(ModalConfirmationComponent);
        (<ModalConfirmationComponent>modal.content).showConfirmationModal(
            'Eliminar dirección',
            'Va a eliminar esta dirección. ¿Está usted seguro/a?',
            '',
            'Si',
            'No',
            true,
            'fa-exclamation-triangle fa-3x',
            'bg-danger'
        );
        (<ModalConfirmationComponent>modal.content).onClose.subscribe(result => {
            if (result === true) {
                // when pressed Yes
                this.deleteDirection(id);
            } else if (result === false) {
                // when pressed No
            } else {
                // When closing the modal without no or yes
            }
        });
    }


    muestraError(errorCode: HttpErrorResponse, mensaje: string) {
        this.getUserAddresses();
        this.backToCreateAddress();
    }


    //  Perform preliminary processing configurations
    preProcessConfigurations(mensaje: string) {
        this.mensajeToShow = mensaje;
        this.statusCode = null;
        this.requestProcessing = true;
    }
    //  Go back from update to create
    backToCreateAddress() {
        this.directionIdToUpdate = null;
        this.model = new Direcciones();
        this.directionForm.reset();
        this.processValidation = false;
        this.selectedIdProvincia = 0;
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template);
        this.modalService.onHide.subscribe(() => {
            this.backToCreateAddress();
        });
    }

    openNewModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template);
        this.modalService.onHide.subscribe(() => {
            this.backToCreateAddress();
        });
    }

    closeModal() {
        this.backToCreateAddress();
        this.modalRef.hide();
    }

    onSelectProvincia(index): void {
        this.selectedIdProvincia = index;
        this.directionForm.patchValue({ ID_PROVINCIA: this.selectedIdProvincia });
    }

    checkCodPostal(value: number) {
        if (value < 1000 || value === undefined) {
            this.minCodPostal = true;
            return;
        }
        this.minCodPostal = false;
    }


    ngOnDestroy() {
        // console.log('Clear direcciones component');
        if (!this.subscription_get_prov == null) { this.subscription_get_prov.unsubscribe(); }
        if (!this.subscription_update == null) { this.subscription_update.unsubscribe(); }
        if (!this.subscription_get == null) { this.subscription_get.unsubscribe(); }
        if (!this.subscription_delete == null) { this.subscription_delete.unsubscribe(); }
        if (!this.subscription_add == null) { this.subscription_add.unsubscribe(); }
        this.translateService = null;
        this.http = null;
        this.direccionesservice = null;
        this.usersservice = null;
        this.toastr = null;
        this.modalService = null;
        this.populateservice = null;

    }

    onResized(event: ResizedEvent): void {
        if (this.table !== undefined) {
            setTimeout(() => {
                this.table.recalculate();
                window.dispatchEvent(new Event('resize'));
            }, (50));
        }
    }

    getRowClassDefault = (row) => {
        return { 'datatable-body-row bg-success': row.DEFAULT };
    }

    exportData() {
        const csv = this.generateCSVFromAddresses();

        const fileName = this.translateService.instant('direcciones.exportFileName') + '.csv';

        this.utilservice.downloadDataInCSV(fileName, csv);
    }

    private generateCSVFromAddresses(): string {
        let csvString = this.convertValuesToCSVRow(this.tableColumns.map(column => column.name));
        this.userAddresses.forEach(value => {
            csvString += this.convertValuesToCSVRow(this.tableColumns.map(column => value[column.prop]));
        });
        return csvString;
    }

    private convertValuesToCSVRow(values: string[]): string {
        // quitamos los saltos de línea en el replace
        return values.map(value => typeof value === 'string' ? value.replace(/(\r\n|\n|\r)/gm, '') : value).join(';') + '\n';
    }
}
